import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';

import { useIndicatorProduct } from './useIndicatorProduct';

export const useIsConservation = () => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];

  return purchasedIndicatorProducts.some((product) => product.name === INDICATOR.CONSERVATION);
};
